<template>
  <div class="sub-fields">
    <template v-for="subField in fields">
      <b-form-group
        :label="`${subField.label.text} ${setRequiredMarkerToLabel(subField.fields)}`"
        label-cols="4"
        :description="subField.label.description"
        :label-for="subField.label.for"
        :key="subField.id"
        class="subfield-form-group"
      >
        <template v-for="field in subField.fields">
          <b-text
            v-if="isBasicField(field) && field.id"
            :tab="tab"
            :key="field.id"
            :className="getColSizes(field)"
            :id="field.id"
            :type="getFieldType(field)"
            :field="field.id"
            :placeholder="field.placeholder"
            :required="getValidationRules(field.required)"
            :appendText="field.appendedText"
            :helpText="field.helpText"
            :isSubField="true"
          />
          <b-number
            v-if="isNumberField(field) && field.id"
            :tab="tab"
            :key="field.id"
            :className="getColSizes(field)"
            :id="field.id"
            type="number"
            :placeholder="field.placeholder"
            :field="field.id"
            :rules="field.rule"
            :appendText="field.appendedText"
            :helpText="field.helpText"
            :format="field.format"
          />
        </template>
      </b-form-group>
    </template>
  </div>
</template>

<script>
  import BText from '@/components/application/Form/FormComponents/BText.vue'
  import BNumber from '@/components/application/Form/FormComponents/BNumber.vue'

  export default {
    components: {
      BText,
      BNumber
    },
    props: {
      fields: Array,
      tab: {
        type: String,
        required: true
      }
    },
    methods: {
      getValidationRules (rule) {
        if (rule) {
          return 'required'
        }
        return null
      },
      getFieldType: (field) => {
        const fieldType = field.fieldType
        let htmltype = ''
        switch (fieldType) {
        case 'text':
          htmltype = 'text'
          break
        case 'number':
          htmltype = 'number'
          break
        case 'date':
          htmltype = 'date'
          break
        }
        return htmltype
      },
      isBasicField: (field) => {
        const fieldType = field.fieldType
        if (['text'].indexOf(fieldType) > -1) {
          return true
        }
        return false
      },
      isNumberField: field => (field.fieldType === 'number'),
      getColSizes: (field) => {
        const sizes = field.sizes
        if (sizes !== null) {
          let css = ''
          if (sizes.col !== null) {
            css += 'col-' + sizes.col + ' '
          }

          if (sizes.colSm !== null) {
            css += 'col-sm-' + sizes.colSm + ' '
          }

          if (sizes.colMd !== null) {
            css += 'col-md-' + sizes.colMd + ' '
          }

          if (sizes.colLg !== null) {
            css += 'col-lg-' + sizes.colLg + ' '
          }

          if (sizes.colXl !== null) {
            css += 'col-xl-' + sizes.colXl + ' '
          }

          return css
        } else {
          return null
        }
      },
      setRequiredMarkerToLabel (fields) {
        if (fields.some(field => field.rule === 'required')) {
          return '*'
        }
        return ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sub-fields::v-deep{
    .subfield-form-group{
      margin: 0;
    }
  }
</style>
